import { render } from "./CompentencyHeaderTitle.vue?vue&type=template&id=048c7b94&scoped=true"
import script from "./CompentencyHeaderTitle.vue?vue&type=script&lang=ts"
export * from "./CompentencyHeaderTitle.vue?vue&type=script&lang=ts"

import "./CompentencyHeaderTitle.vue?vue&type=style&index=0&id=048c7b94&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-048c7b94"

export default script